export const en = {
  common: {
    home: 'Home',
    generator: 'Generator',
    login: 'Login',
    register: 'Register',
    logout: 'Logout',
    dashboard: 'Dashboard',
    email: 'Email',
    password: 'Password',
    fullName: 'Full Name',
    submit: 'Submit',
    cancel: 'Cancel',
    close: 'Close',
    save: 'Save',
    delete: 'Delete',
    edit: 'Edit',
    loading: 'Loading...',
    error: 'Error',
    success: 'Success',
    welcome: 'Welcome',
    user: 'User',
    subscribe: 'Subscribe',
    back: 'Back',
    sort: 'Sort',
    search: 'Search',
    previous: 'Previous',
    next: 'Next',
    optional: 'optional',
    yes: 'Yes',
    no: 'No',
    vs: 'vs',
    free: 'Free',
    reset: 'Reset',
    updating: 'Updating...',
    expert: 'Expert',
    unknown: 'Unknown',
    roi: 'ROI',
    followers: 'followers',
    follow: 'Follow',
    following: 'Following',
    unfollow: 'Unfollow',
    verified: 'Verified',
    viewProfile: 'View {name} profile',
    lastPicks: 'Last {count} picks',
    openDrawer: 'Open menu',
    closeDrawer: 'Close menu',
    closeModal: 'Close',
    gameUnavailable: 'Game unavailable',
    expertNotFound: 'Expert not found',
    expertNumber: 'Expert #{id}',
    paginationShort: '{page} / {totalPages}',
    totalCount: '({total} total)',
    odds: 'odds',
    stake: 'Stake',
    live: 'Live',
    today: 'Today',
    yesterday: 'Yesterday',
    tomorrow: 'Tomorrow',
    daysAgo: '{days}d ago',
    weeksAgo: '{weeks}w ago',
  },
  nav: {
    philipSnatModels: 'Predictions',
    hub: 'Hub',
    generator: 'Generator',
    experts: 'Experts',
    simulator: 'Simulator',
    profile: 'Profile',
    language: 'Language',
    plans: 'Plans',
    becomeExpert: 'Become Expert',
    expertPanel: 'Expert Panel',
    adminPanel: 'Admin Panel',
    login: 'Login',
    register: 'Register',
    logout: 'Logout',
    searchExperts: 'Search Experts',
    following: 'Following',
    recommendations: 'Recommendations',
    dashboard: 'Dashboard',
    myParlays: 'My Parlays',
    myProfile: 'My Profile',
    stats: 'Stats',
    settings: 'Settings',
    brandAlt: 'Philip Snat',
  },
  home: {
    title1: 'Find best plays',
    title2: 'for',
    googleSignIn: 'Google authentication',
    plan: {
      miniText: 'Access tier',
    },
    textCarousel: [
      "NBA",
      "Premier League",
      "NFL",
      "Serie A",
      "MLB",
      "NHL",
      "La Liga",
      "Bundesliga",
      "Ligue 1",
      "Tennis WTA",
      "Eredivisie",
      "Ekstraklasa"
    ],
    heroSub: 'Follow expert tipsters, track their picks, and build your own reputation. Browse verified experts or apply to share your own picks with the community.',
    searchExperts: 'Search Experts',
    becomeExpert: 'Become Expert',
    addRecommendation: 'Add Recommendation',
    sportsArenaAlt: 'Sports arena',
  },
  generator: {
    title: 'Make your parlay',
    generate: 'Generate',
    saveParlay: 'Save parlay',
    setParlayName: 'Set parlay name',
    noEvents: 'No betting events available at the moment',
    loading: 'Loading events...',
  },
  filters: {
    sport: 'Sport',
    all: 'All',
    filters: 'Filters',
    marketSelection: 'Market Selection',
    league: 'League',
    eventsNumber: 'Events Number',
    minOdds: 'Min Odds',
    maxOdds: 'Max Odds',
    oddsRange: 'Odds',
    stakeRange: 'Stake (u)',
    rangeMinAbbrev: 'Min',
    rangeMaxAbbrev: 'Max',
    fromDate: 'From Date',
    toDate: 'To Date',
    moreFilters: 'More filters',
    clearFilters: 'Clear filters',
    selectSport: 'Select Sport',
    selectLeague: 'Select League',
    loadingSports: 'Loading sports...',
    loadingLeagues: 'Loading leagues...',
    noLeaguesAvailable: 'No leagues available',
    selectSportFirst: 'Select a sport first',
    followingTipstersOnly: 'Following only',
    outcome: 'Outcome',
    outcomeAll: 'All outcomes',
    outcomeWin: 'Win',
    outcomeLoss: 'Loss',
    outcomePending: 'Pending',
    outcomeVoid: 'Void',
    minStake: 'Min Stake',
    maxStake: 'Max Stake',
  },
  expertsRecommendationsFeed: {
    title: 'Recommendations',
    subtitle: 'Free picks from all experts',
    shuffle: 'Shuffle order',
    prevPage: 'Previous',
    nextPage: 'Next',
    pageOf: 'Page {page} of {totalPages}',
    empty: 'No picks match your filters.',
    loadError: 'Could not load recommendations.',
    viewExpert: 'View expert',
    followingFilterAria: 'Following filter',
  },
  parlaySummary: {
    totalOdds: 'Total Odds',
    odds: 'Odds',
    minMax: 'Min/Max',
    firstEvent: 'First Event',
    lastEvent: 'Last Event',
    na: 'N/A',
  },
  login: {
    title: 'Login',
    email: 'Email',
    password: 'Password',
    submit: 'Login',
    loginFailed: 'Login failed',
    validationError: 'Validation error',
    emailNotVerified: 'Please verify your email before logging in.',
    resendVerification: 'Resend verification email',
    resendSuccess: 'Verification email sent! Check your inbox.',
    emailVerifiedSuccess: 'Email verified! You can now log in.',
    emailVerifiedExpired: 'Verification link expired. Please request a new one below.',
    emailVerifiedInvalid: 'Invalid verification link.',
    forgotPassword: 'Forgot password?',
    passwordResetSuccess: 'Password reset successfully. You can now log in.',
  },
  forgotPassword: {
    title: 'Forgot password',
    email: 'Email',
    submit: 'Send reset link',
    successMessage: 'If an account with that email exists, we\'ve sent reset instructions.',
    backToLogin: 'Back to login',
    genericError: 'Something went wrong. Please try again.',
  },
  resetPassword: {
    title: 'Reset password',
    newPassword: 'New password',
    confirmPassword: 'Confirm password',
    submit: 'Set new password',
    passwordMismatch: 'Passwords do not match.',
    successRedirecting: 'Password reset! Redirecting to login…',
    invalidToken: 'This reset link is invalid or has expired.',
    genericError: 'Something went wrong. Please try again.',
  },
  register: {
    title: 'Register',
    email: 'Email',
    password: 'Password',
    repeatPassword: 'Repeat password',
    birthdate: 'Date of Birth',
    selectCountry: 'Select Country',
    submit: 'Create account',
    success: 'Account created! Check your inbox to verify your email.',
    registrationFailed: 'Registration failed',
    validationError: 'Validation error',
    passwordMismatch: 'Passwords do not match',
    stepIndicator: 'Step {n} of 5',
    back: 'Back',
    continue: 'Continue',
    notExpertLink: "I don't need to be an expert, just looking for picks",
    notExpertSubline: 'You can always become an expert later.',
    onlyLookingForPicks: 'Only looking for best picks!',
    previewNamePlaceholder: 'Your name',
    identityTitle: "Let's build your profile",
    identitySubtitle: 'Start with how others will see you.',
    nameLabel: 'Others will see you as?',
    namePlaceholder: 'e.g. Paul Mitchell',
    countryLabel: 'Where are you from?',
    shuffle: 'Shuffle avatar',
    sportsTitle: 'What sports do you like the most?',
    sportsSubtitle: 'Choose two.',
    leagueTitle: 'What league do you like the most?',
    leagueSubtitle: 'Pick your favourite.',
    descriptionTitle: 'How would you describe yourself?',
    descriptionSubtitle: 'A short bio for your profile.',
    descriptionLabel: 'Short bio',
    descriptionPlaceholder: 'Tell us about your betting expertise, strategies, and what makes you stand out...',
    accountTitle: 'Create your account',
    accountSubtitle: 'Last step — your login details.',
  },
  becomeExpert: {
    title: 'Become an Expert',
    subtitle: 'Share your betting expertise and build your following',
    description: 'Description',
    descriptionPlaceholder: 'Tell us about your betting expertise, strategies, and what makes you stand out...',
    submit: 'Submit Application',
    success: 'Congratulations! You are now an expert.',
    alreadyExpert: 'You are already registered as an expert.',
    error: 'Failed to submit application. Please try again.',
  },
  expertPanel: {
    title: 'Expert Panel',
    subtitle: 'Manage your expert profile and recommendations',
    editProfile: 'Edit Expert Profile',
    manageRecommendations: 'Manage Recommendations',
    manageMonetization: 'Manage Monetization',
    checkYourStory: 'Check your story',
    statistics: 'Statistics',
    setDescription: 'Set Description',
    descriptionSublabel: 'This is what the users will see when they visit your profile.',
    descriptionPlaceholder: 'Tell us about your betting expertise, strategies, and what makes you stand out...',
    save: 'Save Changes',
    saving: 'Saving...',
    saveSuccess: 'Profile updated successfully!',
    saveError: 'Failed to update profile. Please try again.',
    avatarColor1: 'Color 1',
    avatarColor2: 'Color 2',
    avatarPickColor: 'Pick color',
  },
  manageRecommendations: {
    subtitle: 'Manage your betting recommendations',
    addRecommendations: 'Add recommendations',
    addRecommendationTitle: 'Add Recommendation',
    backToRecommendations: 'Back',
    currentRecommendations: 'Your Recommendations',
    noRecommendations: 'No recommendations yet. Add your first one!',
    noDescription: 'No description provided',
    allTiers: 'All Tiers',
    tierFilterLockedHint: 'Tier filter cannot be changed right now.',
    tierSelectLockedHint: 'Recommendations are added for the Free tier.',
    popularGames: 'Popular Games',
    noPopularGames: 'No popular games available',
    orSearch: 'Or search',
    searchTeams: 'Search Teams',
    searchPlaceholder: 'Lakers, Arsenal...',
    games: 'Games',
    noGamesFound: 'No games found',
    backToGames: 'Back to games',
    availableBets: 'Available Bets',
    otherTab: 'Other',
    under: 'Under',
    over: 'Over',
    untitledMarketGroup: '—',
    noBetsAvailable: 'No bets available for this game',
    addRecommendation: 'Add',
    tierLabel: 'Tier',
    stakeLabel: 'Stake',
    descriptionLabel: 'Description',
    stakePlaceholder: 'Enter stake (e.g. 1.5)',
    descriptionPlaceholder: 'Add your analysis or reasoning...',
    noTiers: 'No tiers available',
    submitError: 'Failed to add recommendation. Please try again.',
    recommendationAdded: 'Recommendation added successfully!',
    addWarning: 'This action is permanent. Once added, a recommendation cannot be deleted. If your statistics matter to you, review your pick carefully before confirming.',
  },
  manageMonetization: {
    currentPlans: 'Current Plans',
    addNew: 'Add new',
    noPlans: 'No plans yet. Create your first plan!',
    connect: 'Connect bank account',
    connectDescription: 'Start earning from your picks. Connect your bank account via Stripe.',
    connecting: 'Connecting...',
    connectPending: 'Complete Stripe setup',
    connectPendingDesc: 'Your account was created. Click to finish the Stripe onboarding and start receiving payments.',
    connectSuccess: 'Bank account connected',
    connectSuccessDesc: 'You\'re all set. Users can now buy 30-day access to your plans.',
  },
  dashboard: {
    title: 'Dashboard',
    logout: 'Logout',
    welcome: 'Welcome',
    email: 'Email',
    plan: 'Plan',
    status: 'Status',
    subscriptionStatus: 'Subscription Status',
    expert: 'Expert',
    expires: 'Expires',
    noActiveSubscription: 'No active subscription. Upgrade to unlock premium features!',
    proFeaturesAccess: 'You have access to Pro features!',
    fullFeaturesAccess: 'You have access to Full/Elite features!',
    quickStats: 'Quick Stats',
    totalParlays: 'Total Parlays',
    winRate: 'Win Rate',
  },
  betEventPanel: {
    lock: 'Lock event',
    unlock: 'Unlock event',
    tbd: 'TBD',
    leagueFallback: 'League {id}',
  },
  protectedRoute: {
    loading: 'Loading...',
  },
  features: {
    proFeaturesTitle: 'Pro Features',
    proFeaturesDescription: 'This page is only accessible to Pro subscribers (hierarchy_order >= 1)!',
    basicFeaturesTitle: 'Basic Features',
    basicFeaturesDescription: 'This page is accessible to Basic subscribers and above (hierarchy_order >= 0)!',
  },
  errors: {
    networkError: 'Network error. Please check your connection.',
    unauthorized: 'You are not authorized to perform this action.',
    validationError: 'Please check your input and try again.',
    genericError: 'Something went wrong. Please try again.',
    failedToFetchEvents: 'Failed to fetch bet events',
    failedToGenerateEvents: 'Failed to generate bet events',
    loginRequiredForFilter: 'Log in or register to use {filter} filter',
  },
  success: {
    loginSuccess: 'Welcome back!',
    registerSuccess: 'Account created successfully!',
    profileUpdated: 'Profile updated successfully!',
    parlaySaved: 'Parlay saved successfully!',
  },
  footer: {
    rights: 'All rights reserved.',
    privacyPolicy: 'Privacy Policy',
    termsOfService: 'Terms of Service',
    cookiePolicy: 'Cookie Policy',
    howPayoutsWork: 'How Payouts Work',
  },
  myParlays: {
    noParlays: 'No parlays saved yet. Create your first parlay in the Generator!',
    event: 'event',
    events: 'events',
    couponResult: {
      WON: 'Won',
      LOST: 'Lost',
      PENDING: 'Pending',
      VOID: 'Void',
    },
    legResult: {
      win: 'Win',
      lost: 'Lost',
      void: 'Void',
      pending: 'Pending',
    },
    deleteParlay: 'Delete parlay',
    deleteParlayConfirm: 'Delete this parlay? This cannot be undone.',
    deleteParlayFailed: 'Could not delete parlay.',
  },
  philipSnatStats: {
    statsCalculatedOnModelVersion: 'Stats calculated on model version from day: {date}',
  },
  experts: {
    searchTitle: 'Search Experts',
    expertFilters: 'Expert filters',
    tagPlaceholder: 'Search by tag (e.g. NBA)',
    sortFollowers: 'Followers',
    sortAppreciation: 'Appreciation',
    sortCurrentPicks: 'Current picks',
  },
  expertProfile: {
    back: 'Back',
    winRate: 'Win Rate',
    picks: 'Picks',
    followers: 'Followers',
    fullStats: 'Full Stats',
    buyAccess: 'Buy Access',
    currentPicks: 'Current Picks',
    resolved: 'Resolved',
    noActivePicks: 'No active picks at the moment',
    noResolvedPicks: 'No resolved picks yet',
    accessActiveBanner: 'Payment successful — you now have 30-day access!',
    accessPendingBanner: 'Payment received — activating your access…',
  },
  expertStats: {
    back: 'Back',
    followers: '{count} followers',
    filters: 'Filters',
    sport: 'Sport',
    league: 'League',
    tier: 'Tier',
    odds: 'Odds',
    stakeMin: 'STAKE ≥',
    totalPicks: 'Total Picks',
    winRate: 'Win Rate',
    avgOdds: 'Avg Odds',
    performance: 'Performance',
    picksByLeague: 'Picks by League',
    picksBySport: 'Picks by Sport',
    roiTimeline: 'ROI Timeline',
    picksBreakdown: 'Picks Breakdown',
    topLeague: 'Top League',
    mostPlayedLeague: 'Most Played League',
    roiPercent: '{roi}% ROI',
    picksCount: '{count} picks',
    picksPerWeek: 'Picks / Week (4W)',
    last4Weeks: 'last 4 weeks',
    withDescription: 'With Description',
    percentOfPicks: '{percent}% of picks',
    lastPick: 'Last Pick',
    date: 'Date',
    match: 'Match',
    stake: 'Stake',
    result: 'Result',
    loadingPicks: 'Loading picks…',
    noPicksFound: 'No picks found',
    stakeHint: "if you'd staked $10 per unit",
    noResolvedPicksInPeriod: 'No resolved picks in this period',
    noDataForPeriod: 'No data for this period',
    ofPicksInLeague: 'of picks are in {label}',
    ofPicksAreSport: 'of picks are {label}',
  },
  hub: {
    topExperts: 'Top Experts',
    rankedByRoi: 'Ranked by ROI',
    noStatsYet: 'No stats available yet',
    lastTopPicks: 'Last Top Picks',
    biggestOddsWon: 'Biggest odds won in last {days} days',
    noWinningPicks: 'No winning picks in this period',
    last30Days: '30 days',
    last7Days: '7 days',
    last3Days: '3 days',
    ever: 'Ever',
  },
  feed: {
    upcomingPicks: 'Upcoming picks',
    currentPicks: 'Current picks',
    featured: 'Featured',
    versus: 'versus',
    home: 'home',
    away: 'away',
    homeStrip: '1 · Home',
    drawStrip: 'X · Draw',
    awayStrip: '2 · Away',
    viewPicks: 'View picks →',
    picksLive: '{count} picks live',
    expertAnalyses: '{count} expert analyses',
    picksCount: '{count} picks',
    expertsCount: '{count} experts',
    picksAndExperts: '{picks} · {experts}',
  },
  gameRecs: {
    backToFeed: '← Expert Feed',
    recommendations: 'Recommendations',
    experts: 'Experts',
    noExpertPicks: 'No expert picks for this game yet.',
    expertPicks: 'Expert Picks',
    loadError: 'Could not load recommendations.',
  },
  registerBenefits: {
    title: 'Logged users benefits',
    benefit1: 'Get free picks from all experts',
    benefit2: 'Use all filters in a generator',
    benefit3: 'Be able to follow other experts',
    benefit4: 'Be able to become an expert',
    benefit5: 'Monetize your tips',
    benefit6: 'Save your plays and see your stats',
  },
  monetization: {
    level: 'Level',
    name: 'Name',
    nameRequired: 'Name *',
    price: 'Price',
    priceMonthly: 'Price ($ / 30 days)',
    description: 'Description',
    editPlan: 'Edit Plan',
    saveChanges: 'Save Changes',
    namePlaceholder: 'e.g. Basic, Pro, Elite',
    pricePlaceholder: '0.00',
    descriptionPlaceholder: 'Describe the features of this plan...',
    perMonth: '${price} / 30 days',
    access30Days: '30-day access',
    featuresList: 'Features',
    addFeature: 'Add feature',
    featurePlaceholder: 'e.g. Access to all picks',
    featured: 'Featured tier',
    tierColor: 'Tier color',
  },
  expertPanelExtras: {
    tag1: 'Tag 1',
    tag2: 'Tag 2',
    tag3: 'Tag 3',
    tagPlaceholderSport: 'e.g. Soccer',
    tagPlaceholderLeague: 'e.g. NBA',
    tagPlaceholderStyle: 'e.g. High odds',
    accountCreatedOn: 'Expert account created on: {date}',
    editRecommendation: 'Edit Recommendation',
    updateRecommendation: 'Update Recommendation',
    updateFailed: 'Failed to update recommendation',
  },
  matchDashboard: {
    classifiers: 'Classifiers',
    classifiersCaption: 'Expected goals per model',
    total: 'Total',
    predictedScore: 'Predicted score',
    expectedGoals: 'Expected goals',
    home: 'Home',
    away: 'Away',
    winProbability: 'Win probability',
    regulation: 'Regulation',
    goals: 'Team goals',
    totalGoals: 'Total goals',
    distribution: 'Distribution',
    overUnder: 'Over / under',
    over: 'over',
    under: 'under',
    win: 'win',
    markets: 'Other markets',
    allGames: 'All games',
    matchResult: 'Match result',
    btts: 'Both teams score',
    winToNil: 'win to nil',
    correctScore: 'Score',
    noDraw: 'no draw',
  },
  philipSnat: {
    modelsTitle: 'Philip Snat Models',
    modelsSubtitle: 'Machine learning models predictions',
    hockey: 'Hockey',
    soccer: 'Soccer',
    today: 'Today',
    gamesCount: { one: '{count} game', other: '{count} games' },
    statsButton: 'Stats',
    noCsvFiles: 'No CSV files available',
    predictionStats: 'Prediction Stats',
    noStatsAvailable: 'No stats available',
    showAllGames: 'Show all games',
    hideGames: 'Hide games',
    correctPicks: 'Correct picks',
    fileIdRequired: 'File ID is required',
    noDataAvailable: 'No data available',
    loadCsvFailed: 'Failed to load CSV data',
    download: 'Download',
    view: 'View',
    remove: 'Remove',
    deleteConfirm: 'Are you sure you want to delete "{fileName}"?',
    deleteFailed: 'Failed to delete file. Please try again.',
  },
  charts: {
    postingRhythm: 'Posting Rhythm',
    less: 'less',
    more: 'more',
    pick: 'pick',
    picks: 'picks',
    heatmapTooltip: '{day} {hour}:00 — {count} {pickLabel}',
    period7d: '7D',
    period30d: '30D',
    period3m: '3M',
    periodYtd: 'YTD',
    periodAll: 'All',
    days: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
  },
  pickResults: {
    won: 'Won',
    lost: 'Lost',
    void: 'Void',
    pending: 'Pending',
    win: 'Win',
  },
  tiers: {
    free: 'Free',
    pro: 'Pro',
    elite: 'Elite',
    tierN: 'Tier {level}',
  },
  pages: {
    settingsTitle: 'Settings',
    settingsDescription: 'This page will contain user settings and preferences.',
    plansTitle: 'Plans Page',
    plansDescription: 'This page will contain subscription plans.',
    simulatorTitle: 'Simulator',
    simulatorDescription: 'This page will contain the betting portfolio simulator.',
    noStatsBecomeExpert: 'No stats available. Become an expert to track your performance.',
  },
  sports: {
    'Piłka nożna': 'Football',
    'e-Piłka nożna': 'e-Football',
    'Tenis': 'Tennis',
    'Koszykówka': 'Basketball',
    'e-Koszykówka': 'e-Basketball',
    'Siatkówka': 'Volleyball',
    'Hokej na lodzie': 'Ice Hockey',
    'Tenis stołowy': 'Table Tennis',
    'Counter-Strike 2': 'Counter-Strike 2',
    'Sporty walki': 'Combat Sports',
    'Piłka ręczna': 'Handball',
    'e-Hokej na lodzie': 'e-Ice Hockey',
    'Sporty zimowe': 'Winter Sports',
    'Skoki narciarskie': 'Ski Jumping',
    'Dart': 'Darts',
    'League of Legends': 'League of Legends',
    'Badminton': 'Badminton',
    'Baseball': 'Baseball',
    'Bandy': 'Bandy',
    'Biathlon': 'Biathlon',
    'Biegi narciarskie': 'Cross-Country Skiing',
    'Boks': 'Boxing',
    'Bowls': 'Bowls',
    'Call of Duty': 'Call of Duty',
    'Curling': 'Curling',
    'Dota 2': 'Dota 2',
    'Formuła': 'Formula Racing',
    'Futbol amerykański': 'American Football',
    'Futbol australijski': 'Australian Football',
    'Futsal': 'Futsal',
    'Golf': 'Golf',
    'Hokej na rolkach': 'Roller Hockey',
    'Hokej na trawie': 'Field Hockey',
    'Honor of Kings': 'Honor of Kings',
    'Kolarstwo': 'Cycling',
    'Koszykówka 3x3': 'Basketball 3x3',
    'Krykiet': 'Cricket',
    'Lacrosse': 'Lacrosse',
    'Narciarstwo alpejskie': 'Alpine Skiing',
    'Rainbow Six': 'Rainbow Six',
    'Piłka wodna': 'Water Polo',
    'Rozrywka i polityka': 'Entertainment & Politics',
    'Rugby': 'Rugby',
    'Siatkówka plażowa': 'Beach Volleyball',
    'Snooker': 'Snooker',
    'Sporty motorowe': 'Motorsports',
    'Squash': 'Squash',
    'Unihokej': 'Floorball',
    'Valorant': 'Valorant',
    'e-Tenis': 'e-Tennis',
    'Żużel': 'Speedway',
  } as Record<string, string>,
  admin: {
    users: 'Users',
    sportIcons: 'Sport Icons',
    leagues: 'Leagues',
    id: 'ID',
    email: 'Email',
    fullName: 'Full Name',
    country: 'Country',
    admin: 'Admin',
    active: 'Active',
    created: 'Created',
    league: 'League',
    sport: 'Sport',
    download: 'Download',
    downloading: 'Downloading',
    notDownloading: 'Not downloading',
    philipSnatRunners: 'Prediction runs',
    runnerMidnight: 'Midnight run (00:00 UTC)',
    runnerNoon: 'Noon run (12:00 UTC)',
    runnerLeagues: 'Leagues:',
    runnerNoLeagues: 'No leagues enabled',
    runNow: 'Run now',
    runnerStarting: 'Starting…',
    runnerStarted: 'Run started on Railway. Predictions will appear in a few minutes.',
    runnerFailed: 'Failed to start the run.',
    runnerNotConfigured: 'Railway API token is not configured on the backend — manual runs are disabled.',
  },
  myParlaysExtras: {
    noEventsFound: 'No events found.',
  },
  legal: {
    lastUpdated: 'Last updated: {date}',
    terms: {
      title: 'Terms of Service',
      s1Title: '1. About the Platform',
      s1Text: 'Philip Snat is a sports tipster marketplace connecting betting experts ("tipsters") with users interested in browsing their picks. By creating an account or using the platform, you agree to these Terms of Service.',
      s1Notice: 'Transparency notice:',
      s1NoticeText: 'Paid subscriptions to tipsters are not yet live. The platform is currently in early access. These terms will be updated before any monetization features go live.',
      s2Title: '2. Informational Purposes Only',
      s2Text1: 'All picks, predictions, and recommendations displayed on Philip Snat are provided for informational and entertainment purposes only. They do not constitute financial advice, investment advice, or betting advice of any kind.',
      s2Text2: 'You should independently evaluate any picks before acting on them. Never bet more than you can afford to lose.',
      s3Title: '3. No Liability for Losses',
      s3Text: "Philip Snat and its operators are not responsible for any financial losses, gambling losses, or damages of any kind incurred as a result of following any tipster's picks or recommendations displayed on this platform. You use this platform entirely at your own risk.",
      s4Title: '4. Age Requirement',
      s4Text: 'You must be at least 18 years old to use Philip Snat. Due to the gambling-related nature of our content, access by persons under 18 is strictly prohibited. By registering, you confirm that you are 18 years of age or older.',
      s5Title: '5. Account Rules',
      s5Intro: 'By creating an account, you agree to:',
      s5Item1: 'Provide accurate and truthful registration information',
      s5Item2: 'Keep your account credentials secure and not share them with others',
      s5Item3: 'Not create multiple accounts to circumvent any restrictions',
      s5Item4: 'Not use the platform for spam, fraud, or any unlawful activity',
      s5Item5: 'Not post misleading, manipulated, or fabricated picks or results',
      s6Title: '6. Account Suspension and Bans',
      s6Text: 'We reserve the right to suspend or permanently ban accounts that violate these Terms of Service, including but not limited to: providing false information, abusing the platform, engaging in fraudulent activity, or violating applicable laws. Account actions may be taken without prior notice in serious cases.',
      s7Title: '7. Intellectual Property',
      s7Text: 'All platform content, design, and software are the property of Philip Snat. Picks and recommendations posted by tipsters remain their intellectual property. You may not reproduce, distribute, or resell any platform content without express written permission.',
      s8Title: '8. Changes to Terms',
      s8Text: 'We may update these Terms of Service as the platform evolves — especially when monetization features are introduced. We will notify registered users of material changes. Continued use of the platform after changes are posted constitutes acceptance of the updated terms.',
      s9Title: '9. Governing Law',
      s9Text: 'These Terms of Service are governed by the laws of Poland. Any disputes arising from the use of this platform shall be subject to the exclusive jurisdiction of the courts of Poland.',
    },
    privacy: {
      title: 'Privacy Policy',
      s1Title: '1. Introduction',
      s1Text: 'This Privacy Policy explains how Philip Snat ("we", "our", or "us") collects, uses, and protects personal data of users ("you") who register and use our platform. We are committed to protecting your privacy in accordance with the General Data Protection Regulation (GDPR) and applicable Polish and EU data protection law.',
      s2Title: '2. Data We Collect',
      s2Intro: 'We collect the following personal data during registration:',
      s2Email: 'Email address — used to create your account and send verification emails',
      s2FullName: 'Full name — used to identify your account on the platform',
      s2Birthdate: 'Date of birth — used to verify you meet the minimum age requirement (18+)',
      s2Country: 'Country — used for regional compliance purposes',
      s2Outro: 'We do not collect any sensitive personal data beyond what is listed above.',
      s3Title: '3. Email Verification',
      s3Text: 'When you register, we send a confirmation email to the address you provided. This email contains a verification link that is valid for 24 hours. If the link expires before you click it, you can request a new verification email from the login page. We use this process to confirm ownership of your email address and prevent unauthorized account creation.',
      s4Title: '4. Payment Data',
      s4Text: 'We do not currently collect, process, or store any payment data. The platform does not have active paid features at this time. If we introduce payments in the future, this policy will be updated and you will be notified before any payment data is collected.',
      s5Title: '5. Your GDPR Rights',
      s5Intro: 'Under the GDPR, you have the following rights regarding your personal data:',
      s5Access: 'Right to access — you may request a copy of all personal data we hold about you',
      s5Erasure: 'Right to erasure — you may request deletion of your account and all associated personal data',
      s5Portability: 'Right to data portability — you may request an export of your personal data in a machine-readable format',
      s5Rectification: 'Right to rectification — you may request correction of inaccurate personal data',
      s5Object: 'Right to object — you may object to the processing of your personal data',
      s5Outro: 'To exercise any of these rights, please contact us at the address below. We will respond within 30 days as required by the GDPR.',
      s6Title: '6. Contact for Data Requests',
      s6Text: 'For all data-related requests — including access, deletion, and export — please contact us at:',
      s7Title: '7. Data Retention',
      s7Text: 'We retain your personal data for as long as your account is active. When you request deletion of your account, we will remove all associated personal data from our systems within 30 days, unless we are legally required to retain it for a longer period.',
      s8Title: '8. No Third-Party Sharing',
      s8Text: 'We do not sell, trade, rent, or otherwise share your personal data with third parties for commercial purposes. Your data is used solely to operate the Philip Snat platform and to communicate with you regarding your account.',
      s9Title: '9. Legal Basis for Processing',
      s9Text: 'We process your personal data on the legal basis of contract performance (Article 6(1)(b) GDPR) — necessary to provide you with the service you signed up for — and legitimate interests (Article 6(1)(f) GDPR) in operating and improving the platform.',
      s10Title: '10. Governing Law',
      s10Text: 'This Privacy Policy is governed by the laws of Poland and applicable EU data protection regulations, in particular the GDPR.',
    },
    cookies: {
      title: 'Cookie Policy',
      s1Title: '1. What Are Cookies?',
      s1Text: 'Cookies are small text files stored on your device by your browser when you visit a website. They are used to make websites work correctly and to remember your preferences between visits.',
      s2Title: '2. Cookies We Use',
      s2Intro: 'We currently use only strictly necessary cookies. These are essential for core platform functionality and cannot be disabled without breaking the service.',
      tableCookie: 'Cookie',
      tablePurpose: 'Purpose',
      tableDuration: 'Duration',
      authPurpose: 'Keeps you logged in to your account',
      authDuration: 'Session / until logout',
      emailVerifyPurpose: 'Used during the email verification flow at registration',
      emailVerifyDuration: '24 hours',
      languagePurpose: 'Remembers your preferred interface language (stored in localStorage)',
      languageDuration: 'Persistent',
      s3Title: '3. No Analytics or Third-Party Cookies',
      s3Text: 'We do not currently use analytics cookies (such as Google Analytics), advertising cookies, tracking cookies, or any cookies set by third parties. No data about your browsing behaviour is collected for marketing or profiling purposes.',
      s4Title: '4. How to Clear Cookies',
      s4Intro: 'You can clear or block cookies at any time through your browser settings. Note that clearing authentication cookies will log you out of your account. Instructions for common browsers:',
      s4Chrome: 'Chrome: Settings → Privacy and security → Clear browsing data → Cookies and other site data',
      s4Firefox: 'Firefox: Settings → Privacy & Security → Cookies and Site Data → Clear Data',
      s4Safari: 'Safari: Settings → Privacy → Manage Website Data → Remove All',
      s4Edge: 'Edge: Settings → Privacy, search, and services → Clear browsing data → Cookies and other site data',
      s5Title: '5. Future Changes',
      s5Text: 'If we introduce non-essential cookies in the future — for example, analytics or advertising — we will update this Cookie Policy and obtain your consent before placing any non-essential cookies on your device.',
    },
  },
  eventsDictionary: {
    'z dogrywką i rzutami karnymi': 'incl. OT & shootout',
    'z dogrywką': 'incl. OT',
    'bez dogrywki i rzutów karnych': 'excl. OT & shootout',
    'bez dogrywki': 'excl. OT',
    'obie drużyny strzelą gola': 'both teams to score',
    'obie drużyny strzelą': 'both teams to score',
    'dokładna liczba goli': 'exact number of goals',
    'dokładna liczba punktów': 'exact number of points',
    'dokładna liczba zbiórek': 'exact number of rebounds',
    'dokładna liczba asyst': 'exact number of assists',
    'liczba goli w meczu': 'total goals in match',
    'liczba goli': 'number of goals',
    'liczba asyst': 'number of assists',
    'liczba zbiórek': 'number of rebounds',
    'liczba punktów': 'number of points',
    'liczba rzutów': 'number of shots',
    'liczba żółtych kartek': 'number of yellow cards',
    'liczba czerwonych kartek': 'number of red cards',
    'podwójna szansa': 'double chance',
    'pierwsza połowa': 'first half',
    'druga połowa': 'second half',
    'rzuty karne': 'penalty shootout',
    'rzut karny': 'penalty',
    'dogrywka': 'overtime',
    'wynik meczu': 'match result',
    'wynik': 'result',
    'handicap azjatycki': 'asian handicap',
    'handicap': 'handicap',
    'wygra lub zremisuje': 'to win or draw',
    'wygra mecz': 'to win',
    'wygra': 'to win',
    'strzelą gola': 'to score',
    'remis w meczu': 'draw',
    'remis': 'draw',
    'nieparzysta': 'odd',
    'parzysta': 'even',
    'poniżej': 'under',
    'powyżej': 'over',
    'zawodnik': 'player',
    'tercja': 'period',
    'kwarta': 'quarter',
    'mecz': 'match',
    'gol': 'goal',
    'połowa': 'half',
    'zakład bez remisu': 'no draw bet',
    'zawodnika': 'player',
    'strzeli gola': 'to score',
    'Kto pierwszy wykona X rzutów różnych': 'Who will make the first X corners',
    'Dokładny wynik': 'Exact score',
    'Rzuty rożne': 'Corners',
    'liczba oddanych rzutów za 3pkt': 'number of 3-point shots',
    'strzeli gola lub zaliczy asystę': 'to score or to assist',
    'rzutów rożnych': 'corners',
    'liczba rzutów rożnych': 'number of corners',
    'Wszystkie tercje poniżej X goali': 'All periods under X goals',
    'zaliczy asystę': 'to assist',
    'liczba bloków': 'number of blocks',
    'tak': 'yes',
    'nie': 'no',
    'strzeli 3+ goli': 'to score 3+ goals',
    'strzeli 3+ gole': 'to score 3+ goals',
    'strzeli 2+ goli': 'to score 2+ goals',
    'strzeli 2+ gole': 'to score 2+ goals',
    'strzeli 1+ goli': 'to score 1+ goals',
    'strzeli 1+ gole': 'to score 1+ goals',
    'Liczba celnych strzałów ': 'number of shots on target',
    'liczba zbiórek + asyst': 'number of rebounds + assists',
    'liczba punktów + zbiórek': 'number of points + rebounds',
    'wynik dowolnej połowy meczu': 'result of any half',
    'liczba strat': 'number of losses',
    'strzeli ostatnogo gola': 'to score the last goal',
    'strzeli ostatniego gola': 'to score the last goal',
    'liczba trafionych rzutów za 3pkt': 'number of 3-pointers',
    'która drużyna': 'which team',
    'drużyna': 'team',
    'zdobędzie 1.gola w meczu': 'to score the first goal in the match',
    'w przewadze': 'in advantage',
    'w osłabieniu': 'while shorthanded',
    'bilans goli': 'goal difference',
    'na lodzie': 'on ice',
    'wygra do zera': 'to win by a shutout',
    'różnica zwycięstwa': 'win difference',
    'golami': 'goals',
    'rzut rożny': 'corner',
    'kto wykona': 'who will make',
    'liczba trafionych rzutów wolnych': 'number of succesfull free throws',
    'wygra wcześniej przegrywając': 'win after losing',
    'dokładna liczba kartek': 'exact number of cards',
    'liczba kartek': 'number of cards',
    'liczba oddanych rzutów za 2pkt': 'number of 2-point shots',
    'zwycięzca serii': 'Series winner',
    'kto pierwszy zdobędzie X punktów': 'Who will score the first X points',
    'liczba meczy w serii': 'Number of matches in the series',
    'liczba meczów w serii': 'Number of matches in the series',
    'dokładny wynik serii': 'exact series result',
    'najwięcej zbiórek w serii': 'most rebounds in the series',
    'najwięcej przechwytów w serii': 'most steals in the series',
    'najwiecej trafionych rzutów za 3pkt w serii': 'most successful 3-point shots in the series',
    'najwięcej punktów': 'Most points',
    'pierwsze punkty w meczu': 'first points in the match',
    'zawodnicy': 'players',
    'łączna': 'total',
    'łączna liczba punktów': 'total number of points',
    'najwięcej asyst': 'most assists',
    'zaliczy jako pierwszy asystę': 'to assist as the first',
    'trafione rzuty za 3pkt': 'successful 3-point shots',
    'lub': 'or',
    'nikt': 'nobody',
    'przedział goli': 'goal range',
    'przedziały goli': 'goal range',
    'przedziały': 'ranges',
    'ostatni': 'last',
    'w przynajmniej jednej połowie': 'in at least one half',
    'w obu połowach': 'in both halves',
    'połowa z większą liczbą goli': 'half with more goals',
    'kto pierwszy wykona': 'who will make the first',
    'przedział rzutów rożnych': 'range of corners',
    'wygra przynajmniej jedną połowę': 'to win at least one half',
    'ponad 1.5 gola': 'over 1.5 goals',
    'gole': 'goals',
    'obie połowy': 'both halves',
    'będzie prowadzić w dowolnym momencie': 'to lead at any time',
    'strzeli co najmniej 2 gole z rzędu': 'to score 2+ goals in a row',
    'liczba obronionych strzałów przez bramkarza': 'number of successful shots against the goalkeeper',
    'czy 3. set zostanie rozegrany': 'will the 3rd set be played',
    'dokładna liczba setów': 'exact number of sets',
    'zwycięzca': 'winner',
    'zablokowanych strzałów': 'blocked shots',
    'celnych strzałów': 'shots on goal',
    'punktów zdobytych w przewadze': 'points scored in advantage',
    'wyścig do x goli': 'race to X goals',
    'wyścig do': 'race to',
    'zbiórek': 'rebounds',
    'przechwytów': 'steals',
    'bloków': 'blocks',
    'asyst': 'assists',
    'punktów': 'points',
    'rzutów': 'shots',
    'rzutów za 3pkt': '3-point shots',
    'rzutów za 2pkt': '2-point shots',
    'rzutów wolnych': 'free throws',
    'zdobędzie gola': 'to score a goal',

    // General additions (NFL / MLB / NHL / NBA gaps)
    'liczba': 'number of',
    'więcej': 'more',
    'najwięcej': 'most',
    'zdobędzie': 'to score',
    'zdobędą': 'to score',
    'zdobywa': 'to score',
    'zdobyty': 'scored',
    'zdobytych': 'scored',
    'zdobywca': 'scorer',
    'wykona': 'to make',
    'wykonają': 'to make',
    'przyznanych': 'awarded',
    'obie drużyny': 'both teams',
    'drużyny': 'team',
    'zwycięstwo': 'win',
    'serie': 'series',
    'runów': 'runs',
    'punkty': 'points',
    'punkt': 'point',
    'pierwszy': 'first',
    'gola': 'goal',
    'meczu': 'match',
    'spalonych': 'offsides',
    'pałkarz': 'batter',
    'miotacz': 'pitcher',
    'suma': 'total',
    'dodatkowe': 'additional',
    'strzeli': 'to score',
    'rzutów karnych': 'penalties',
    'rz.rożnych': 'corners',
    'w każdej połowie': 'in each half',
    'w każdej kwarcie': 'in each quarter',
    'w dowolnym momencie': 'at any time',
    'w meczu': 'in the match',
    'liczba wygranych połów': 'number of halves won',
    'liczba zdobytych baz': 'number of total bases',
    'liczba przechwyconych rzutów': 'number of interceptions',
    'extra punktów': 'extra points',
    'singli': 'singles',
    'po X inningach': 'after X innings',
    'zdobywca ostatni touchdown': 'last touchdown scorer',
    'zdobywca last touchdown': 'last touchdown scorer',
    'zdobędzie 1.touchdown': 'to score the 1st touchdown',
    'zdobędzie touchdown': 'to score a touchdown',
    'zdobyty touchdown': 'touchdown scored',
    'zaliczy home run': 'to hit a home run',
    'zdobędzie bazę': 'to reach base',
    'punkty zawodnika': 'player points',
    'zdobędzie najwięcej punktów': 'to score the most points',
    'sposób awansu drużyny': 'team qualification method',
    'sposób zwycięstwa drużyny': 'team win method',
    'sposób awansu/którakolwiek drużyna': 'team qualification method (either team)',
    'sposób zwycięstwa/którakolwiek drużyna': 'team win method (either team)',
    'najdłuższy': 'longest',
    'z najmniejszą liczbą': 'with the fewest number of',
    'z największą liczbą': 'with the highest number of',
    'każda z drużyn': 'each team',

    // Countries
    'Niemcy': 'Germany',
    'Francja': 'France',
    'Anglia': 'England',
    'Hiszpania': 'Spain',
    'Włochy': 'Italy',
    'Holandia': 'Netherlands',
    'Portugalia': 'Portugal',
    'Belgia': 'Belgium',
    'Szkocja': 'Scotland',
    'Turcja': 'Turkey',
    'Rosja': 'Russia',
    'Ukraina': 'Ukraine',
    'Polska': 'Poland',
    'Czechy': 'Czech Republic',
    'Republika Czeska': 'Czech Republic',
    'Słowacja': 'Slovakia',
    'Austria': 'Austria',
    'Szwajcaria': 'Switzerland',
    'Dania': 'Denmark',
    'Szwecja': 'Sweden',
    'Norwegia': 'Norway',
    'Finlandia': 'Finland',
    'Grecja': 'Greece',
    'Chorwacja': 'Croatia',
    'Serbia': 'Serbia',
    'Rumunia': 'Romania',
    'Węgry': 'Hungary',
    'Bułgaria': 'Bulgaria',
    'Słowenia': 'Slovenia',
    'Irlandia Północna': 'Northern Ireland',
    'Irlandia': 'Ireland',
    'Walia': 'Wales',
    'Brazylia': 'Brazil',
    'Argentyna': 'Argentina',
    'Meksyk': 'Mexico',
    'Japonia': 'Japan',
    'Korea Południowa': 'South Korea',
    'Korea Północna': 'North Korea',
    'Korea Płd.': 'South Korea',
    'Korea Płn.': 'North Korea',
    'Korea': 'Korea',
    'Australia': 'Australia',
    'Chiny': 'China',
    'Stany Zjednoczone': 'United States',
    'Maroko': 'Morocco',
    'Senegal': 'Senegal',
    'Nigeria': 'Nigeria',
    'Egipt': 'Egypt',
    'Kamerun': 'Cameroon',

    // South America
    'Urugwaj': 'Uruguay',
    'Kolumbia': 'Colombia',
    'Ekwador': 'Ecuador',
    'Wenezuela': 'Venezuela',
    'Paragwaj': 'Paraguay',
    'Boliwia': 'Bolivia',
    'Chile': 'Chile',
    'Peru': 'Peru',

    // North & Central America / Caribbean
    'Kanada': 'Canada',
    'Kostaryka': 'Costa Rica',
    'Jamajka': 'Jamaica',
    'Trynidad i Tobago': 'Trinidad and Tobago',
    'Honduras': 'Honduras',
    'Salwador': 'El Salvador',
    'Gwatemala': 'Guatemala',
    'Haiti': 'Haiti',
    'Kuba': 'Cuba',
    'Panama': 'Panama',

    // Europe (additional)
    'Izrael': 'Israel',
    'Gruzja': 'Georgia',
    'Czarnogóra': 'Montenegro',
    'Macedonia Północna': 'North Macedonia',
    'Bośnia i Hercegowina': 'Bosnia and Herzegovina',
    'Islandia': 'Iceland',
    'Kosowo': 'Kosovo',
    'Luksemburg': 'Luxembourg',
    'Azerbejdżan': 'Azerbaijan',
    'Albania': 'Albania',
    'Armenia': 'Armenia',
    'Białoruś': 'Belarus',
    'Liechtenstein': 'Liechtenstein',
    'Łotwa': 'Latvia',
    'Litwa': 'Lithuania',
    'Estonia': 'Estonia',
    'Cypr': 'Cyprus',
    'Malta': 'Malta',
    'Mołdawia': 'Moldova',
    'Andora': 'Andorra',
    'Faroe Islands': 'Faroe Islands',
    'Wyspy Owcze': 'Faroe Islands',
    'San Marino': 'San Marino',
    'Gibraltar': 'Gibraltar',

    // Asia
    'Arabia Saudyjska': 'Saudi Arabia',
    'Katar': 'Qatar',
    'Irak': 'Iraq',
    'Indonezja': 'Indonesia',
    'Bahrajn': 'Bahrain',
    'Kuwejt': 'Kuwait',
    'Jordania': 'Jordan',
    'Zjednoczone Emiraty Arabskie': 'UAE',
    'Uzbekistan': 'Uzbekistan',
    'Wietnam': 'Vietnam',
    'Tajlandia': 'Thailand',
    'Malezja': 'Malaysia',
    'Oman': 'Oman',
    'Syria': 'Syria',
    'Liban': 'Lebanon',
    'Palestyna': 'Palestine',
    'Filipiny': 'Philippines',
    'Tajwan': 'Taiwan',
    'Singapur': 'Singapore',
    'Indie': 'India',
    'Pakistan': 'Pakistan',
    'Afganistan': 'Afghanistan',
    'Kazachstan': 'Kazakhstan',
    'Kirgizia': 'Kyrgyzstan',
    'Tadżykistan': 'Tajikistan',
    'Turkmenistan': 'Turkmenistan',
    'Mongolia': 'Mongolia',
    'Mjanma': 'Myanmar',
    'Kambodża': 'Cambodia',
    'Laos': 'Laos',

    // Africa (additional)
    'Wybrzeże Kości Słoniowej': 'Ivory Coast',
    'Algieria': 'Algeria',
    'Tunezja': 'Tunisia',
    'Demokratyczna Republika Konga': 'DR Congo',
    'Republika Południowej Afryki': 'South Africa',
    'Kenia': 'Kenya',
    'Etiopia': 'Ethiopia',
    'Mozambik': 'Mozambique',
    'Tanzania': 'Tanzania',
    'Uganda': 'Uganda',
    'Angola': 'Angola',
    'Zambia': 'Zambia',
    'Zimbabwe': 'Zimbabwe',
    'Mali': 'Mali',
    'Ghana': 'Ghana',
    'Burkina Faso': 'Burkina Faso',
    'Gwinea': 'Guinea',
    'Niger': 'Niger',
    'Benin': 'Benin',
    'Sudan': 'Sudan',
    'Libia': 'Libya',
    'Madagaskar': 'Madagascar',
    'Somalia': 'Somalia',
    'Gabon': 'Gabon',
    'Togo': 'Togo',
    'Kongo': 'Congo',
    'RPA': 'South Africa',

    // Oceania
    'Nowa Zelandia': 'New Zealand',

    // Leagues and competitions
    'Liga Mistrzów': 'Champions League',
    'Liga Europy': 'Europa League',
    'Liga Konferencji Europy': 'Conference League',
    'Liga Konferencji': 'Conference League',
    'Superpuchar Europy': 'UEFA Super Cup',
    'Superpuchar': 'Super Cup',
    'Puchar Niemiec': 'German Cup',
    'Puchar Francji': 'French Cup',
    'Puchar Anglii': 'FA Cup',
    'Puchar Króla': 'Copa del Rey',
    'Puchar Włoch': 'Coppa Italia',
    'Puchar Ligi': 'League Cup',
    'Puchar Polski': 'Polish Cup',
    'Puchar': 'Cup',
    'Mistrzostwa Świata': 'World Cup',
    'Mistrzostwa Europy': 'European Championship',
    'Mistrzostwa': 'Championship',
    'Eliminacje': 'Qualifying',
    'Baraże': 'Playoffs',
    'Faza grupowa': 'Group Stage',
    'Ćwierćfinał': 'Quarter-final',
    'Półfinał': 'Semi-final',
    'Liga Narodów': 'Nations League',
    'Złoty Puchar': 'Gold Cup',
    'Copa America': 'Copa America',
    'Ekstraklasa': 'Ekstraklasa',
    'Pierwsza Liga': 'First Division',
    'Druga Liga': 'Second Division',
  } as Record<string, string>,
};
